// Layer schema
// Drawing layers for organizing and controlling visibility of diagram elements

import { z } from 'zod';

export const LayerSchema = z.object({
  id: z.string(),
  name: z.string(),
  level: z.number().int(),
  opacity: z.number().min(0).max(1),
  visible: z.boolean(),
});

export type Layer = z.infer<typeof LayerSchema>;
